(function (Drupal, $) {

  $(function () {

    const selectElement = document.querySelector('.huk-select .form-select');
    let value = selectElement.options[selectElement.selectedIndex].value;
    let organisationInput = document.getElementsByClassName("js-form-item-search")[0];
    let placeInput = document.getElementsByClassName("js-form-item-location-source-configuration-origin-address")[0];
    let geolocationInput = document.getElementsByClassName("care-finder-form__geolocation")[0];

    geolocationInput.getElementsByTagName('input')[0].disabled = true

    // Set title when page (with results) is refreshed
    setTitle();

    selectElement.addEventListener("change", function( event ) {
      value = selectElement.options[selectElement.selectedIndex].value;

      if (value === 'org') {
        organisationInput.getElementsByTagName('input')[0].value = "";
      } else {
        setTitle();
        placeInput.getElementsByTagName('input')[0].value = "";
      }
    }, false);

    function setTitle() {
      if (value === 'postcode') {
        document.querySelector(".js-form-item-location-source-configuration-origin-address label").innerHTML = "Enter a full or partial postcode below";
      }

      if (value === 'place') {
        document.querySelector(".js-form-item-location-source-configuration-origin-address label").innerHTML = "Enter a city or town";
      }
    }
  });


})(Drupal, jQuery);
